import type { MemberStatsOptions } from './shell/useMemberStats'
import type { PayoutInputsOptions } from './shell/usePayoutInputs'
import type { ReadOnlyMetricsOptions } from './shell/useReadOnlyMetrics'
import { useMemberStats as useMemberStatsShell } from './shell/useMemberStats'
import { usePayoutInputs as usePayoutInputsShell } from './shell/usePayoutInputs'
import { useReadOnlyMetrics } from './shell/useReadOnlyMetrics'

export { VAULT_METRICS_KEY } from './shell/useVaultMetrics'

export function usePoolMetricsReadOnly(options?: ReadOnlyMetricsOptions) {
  return useReadOnlyMetrics(options)
}

/**
 * Pool-wide membership counts. They live here rather than in the member domain so the
 * landing page can read them without loading the member shells and the wallet stack.
 */
export function useMemberStats(options?: MemberStatsOptions) {
  return useMemberStatsShell(options)
}

/** The live inputs every payout figure is projected from, or `null` while any is missing. */
export function usePayoutInputs(options?: PayoutInputsOptions) {
  return usePayoutInputsShell(options)
}
